export default {
  name: "NewBusinessCoverPackages",
  props: {
    title: String,
    instruction: String
  },
  data() {
    return {
      selectedCoverDetail: "",
      selectedCoverDetailLabel: "",
      coverPackageList: [
        {
          code: "P1",
          is_popular: true,
          package_name: "Family Day Care",
          code_name: "Family Day Care",
          description: `This packages covers you for running a traditional family day care and providing education and care for children in your home or residence.`,
          checked: false
        },
        {
          code: "P3",
          is_popular: false,
          package_name: "Family Day Care + In Home Care",
          code_name: "Family Day Care and In Home Care",
          description: `This package is for educators who conduct both family day care from their own home and also In Home Care from the child's home.`,
          checked: false
        },
        {
          code: "P2",
          is_popular: false,
          package_name: "In Home Care",
          code_name: "In Home Care",
          description: `This package is for in-home carers who provide care in the child’s own home only.`,
          checked: false
        },
        {
          code: "P4",
          is_popular: false,
          package_name: "Out of Home Care (OOHC)",
          code_name: "Out of Home Care",
          description: `This package is for family day care educators who provide both family day care and Out of Home Care (OOHC). This package includes a specific extension to account for the needs of children and young people in OOHC.`,
          checked: false
        }
      ],
      coverPackagesSubmitted: false,
    };
  },
  watch: {
    selectedCoverDetail: function(val) {
      switch (val) {
        case "P1":
          this.selectedCoverDetailLabel = this.coverPackageList[0].code_name;
          break;
        case "P2":
          this.selectedCoverDetailLabel = this.coverPackageList[2].code_name;
          break;
        case "P3":
          this.selectedCoverDetailLabel = this.coverPackageList[1].code_name;
          break;
        case "P4":
          this.selectedCoverDetailLabel = this.coverPackageList[3].code_name;
          break;
        default:
          break;
      }
    }
  },
  methods: {
    backToPrevious() {
      this.$store.commit("mutate", {
        property: "NewBusinessStep",
        value: this.$store.state.NewBusinessStep - 1
      });
    },
    submitForm() {
      this.coverPackagesSubmitted = true;
      this.$store.commit("mutate", {
        property: "sessionDetails.properties.package_code",
        value: this.selectedCoverDetail
      });

      this.$store.commit("mutate", {
        property: "sessionDetails.properties.package",
        value: this.selectedCoverDetailLabel
      });

      this.$emit("createUpdateSession");
    }
  },
  mounted() {
    if (this.$store.state.sessionDetails &&
      this.$store.state.sessionDetails.properties.package_code) {
      this.selectedCoverDetail = this.$store.state.sessionDetails.properties.package_code
      let selectedCover = this.coverPackageList.filter(item => item.code === this.selectedCoverDetail);
      this.selectedCoverDetailLabel = selectedCover.code_name;
    }
  }
};
